import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { LanguageSelector } from "@/components/LanguageSelector";
import { Logo } from "@/components/Logo";
import { useTranslation } from "react-i18next";

export const LandingNavigation = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-card border-b border-border shadow-sm">
      <div className="container mx-auto px-6 h-16 flex items-center justify-between">
        <div className="flex items-center cursor-pointer" onClick={() => navigate("/")}>
          <Logo width={180} height={60} />
        </div>

        <div className="flex items-center gap-3">
          <LanguageSelector />
          <Button
            variant="ghost"
            onClick={() => navigate("/auth")}
            className="text-sm"
          >
            {t('nav.signIn')}
          </Button>
          <Button
            onClick={() => navigate("/auth")}
            className="bg-primary hover:bg-primary/90 shadow-glow"
          >
            {t('hero.getStarted')}
          </Button>
        </div>
      </div>
    </header>
  );
};
